import { Loading as LoadingProps } from "./index.types";
import gif from "../../stories/assets/loading.gif";
import "./index.css";

export function Loading({ img, children }: LoadingProps) {
  return (
    <div className="loading">
      <img src={img ?? gif} />
      <div className="loading-message">{children}</div>
    </div>
  );
}

export default Loading;
